// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AutoLogoutController from "./auto_logout_controller"
application.register("auto-logout", AutoLogoutController)

import AutoresizeController from "./autoresize_controller"
application.register("autoresize", AutoresizeController)

import ChartController from "./chart_controller"
application.register("chart", ChartController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import OtpController from "./otp_controller"
application.register("otp", OtpController)

import MobileMenuController from "./mobile_menu_controller"
application.register("mobile-menu", MobileMenuController)

import SearchFormController from "./search_form_controller"
application.register("search-form", SearchFormController)
